import React, { ReactNode, useEffect } from "react";
import SidebarItem from "../PaymentsAppSidebar/SidebarItem";
import { PaymentRoutes } from "../../../Contracts/Routes";
import { ReactComponent as Invoice } from "../../../Assets/PaymentsAppSidebar/Invoice.svg";
import { ReactComponent as Customers } from "../../../Assets/PaymentsAppSidebar/Customers.svg";
import ClientPortalBrandingNameLogo from "../ClientPortalPages/ClientPortalBrandingNameLogo";
import ZomentumLogo from "../../../Assets/PaymentsAppHeader/ZomentumLogo.svg";
import { useCustomerStore } from "../../../Store/Customer";

interface ClientPortalAppLayoutProps {
  children: ReactNode;
}

const ClientPortalAppLayout: React.FC<ClientPortalAppLayoutProps> = ({ children }) => {
  const { getClientPortalCustomers, clientPortalCustomersCount } = useCustomerStore();
  useEffect(() => {
    getClientPortalCustomers();
  }, [getClientPortalCustomers]);
  return (
    <div className="flex flex-col h-screen shadow-lg">
      <nav className="sticky header h-16 flex justify-between z-50">
        <ClientPortalBrandingNameLogo className="m-4" />
        <div className="flex items-center space-x-2 m-4 opacity-60">
          <span className="mt-0.5">Powered by </span>
          <img src={ZomentumLogo} alt="Zomentum Logo" className="w-28" />
        </div>
      </nav>
      <div className="flex flex-grow">
        {clientPortalCustomersCount && clientPortalCustomersCount > 1 && (
          <div className="flex">
            <nav className="flex flex-col inset-y-0 bg-gray-950 shadow-lg">
              <ul className="relative flex flex-col items-center justify-center w-16 ml-1">
                <SidebarItem
                  href={PaymentRoutes.CLIENT_PORTAL_INVOICES}
                  LogoComponent={Invoice}
                  title="Invoices"
                />
                <SidebarItem
                  href={PaymentRoutes.CLIENT_PORTAL_CUSTOMERS}
                  LogoComponent={Customers}
                  title="Customers"
                />
              </ul>
            </nav>
          </div>
        )}
        <div className="flex flex-grow bg-white-smoke">
          <div className="bg-white m-4 p-6 rounded flex-grow shadow-md">{children}</div>
        </div>
      </div>
    </div>
  );
};

export default ClientPortalAppLayout;
